import {createSlice} from '@reduxjs/toolkit';




const initialState = {
    customer :  {
        custId: '',
        custName:'',
        programId:'',
        isToday:false,
        longGPS : 0,
        latGPS : 0
    },

    isFetching: false,
    error: false,
};

export const captureSlice = createSlice({
    name: 'captureSlice',
    initialState,
    reducers: {
        capture_getCustomer: (state, {payload}) => {
            state.customer = payload;
        },
        capture_clearAll: (state) => initialState
    }
});

export const { capture_getCustomer, capture_clearAll } = captureSlice.actions;

export default captureSlice.reducer;
